import { NavLink } from "react-router-dom";
import { useSelector } from "react-redux";

const Landing = () => {
  const { lenguage } = useSelector((s) => s);
  return (
    <>
      <div className="landingPage_container">
        <NavLink to="/home" className="linkhome">
          <div className="bounce-txt">
            {lenguage ? (
              <>
                <div className="b">W</div>
                <div className="i">E</div>
                <div className="e">L</div>
                <div className="n">C</div>
                <div className="v">O</div>
                <div className="e2">M</div>
                <div className="n2">E</div>
                <div className="esp"> </div>
                <div className="i2">T</div>
                <div className="d">O</div>
                <div className="esp"> </div>
                <div className="z">Z</div>
                <div className="o2">O</div>
                <div className="o3">O</div>
                <div className="d2">D</div>
                <div className="o4">O</div>
                <div className="g">G</div>
              </>
            ) : (
              <>
                <div className="b">B</div>
                <div className="i">I</div>
                <div className="e">E</div>
                <div className="n">N</div>
                <div className="v">V</div>
                <div className="e2">E</div>
                <div className="n2">N</div>
                <div className="i2">I</div>
                <div className="d">D</div>
                <div className="o">O</div>
                <div className="s">S</div>
                <div className="esp"> </div>
                <div className="a">A</div>
                <div className="esp"> </div>
                <div className="z">Z</div>
                <div className="o2">O</div>
                <div className="o3">O</div>
                <div className="d2">D</div>
                <div className="o4">O</div>
                <div className="g">G</div>
              </>
            )}
          </div>
        </NavLink>
      </div>
    </>
  );
};

export default Landing;
